import FundsService from "@services/Funds.service";
import {
  SET_FUNDS_DATA,
  UPDATE_BANK_ACCOUNTS,
  UPDATE_CRYPTO_WALLETS,
  DELETE_CRYPTO_WALLET,
  SET_PURCHASE_EXCHANGE_RATES,
  SET_BANK_FORM_ADDRESS_DATA_AVAILABLE,
  UPDATE_WALLET_BALANCE_AFTER_TRANSACTION,
  DELETE_BANK_ACCOUNT,
  UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION,
  SET_ACCESSING_FUNDS_AGREEMENT_CREATED_AT,
} from "./actionTypes";
import { IWalletDetails } from "@market/interfaces/IWallet";
import {
  IPrivateWallets,
  IBankAccountProperties,
} from "@funds/components/WithdrawAmount/IWithdrawAmount";
import { TReducers } from "@features/reducers";
import { getMinutesFromTimestamp } from "@features/utils/functions";
import { TUpdateWalletData } from "@funds/interfaces/IFundsGeneral";
import { IUpdateWalletsData } from "@funds/interfaces/IFundsReducer";
import { ADD_USER_DATA } from "@market/features/actionTypes";
import { SET_API_ME } from "@features/actionTypes";

export const setFundsData =
  (investorId: number, refetch: boolean = false) =>
  (dispatch: Function, getState: () => TReducers) => {
    const timestamp = getState().fundsReducer.timestamp;
    const minutes = getMinutesFromTimestamp(Date.now() - timestamp);

    if (minutes >= 2 || refetch) {
      return Promise.all([
        FundsService.getWallets(investorId),
        FundsService.getBankAccounts(investorId),
        FundsService.getPrivateWallets(investorId),
        FundsService.getPESWallets(investorId),
      ]).then((res) => {
        res[0].data = res[0].data
          .sort(
            (a: IWalletDetails, b: IWalletDetails) =>
              Number(b.total_usd) - Number(a.total_usd)
          )
          .map((wallet: IWalletDetails) => {
            return !wallet.currency_name
              ? { ...wallet, currency_name: wallet.currency?.toUpperCase() }
              : wallet;
          });
        dispatch({
          type: SET_FUNDS_DATA,
          payload: res,
        });
      });
    }

    return Promise.resolve();
  };

export const getPurchaseExchangeRates = () => (dispatch: Function) => {
  return FundsService.getPurchaseExchangeRates("bft").then((res) => {
    dispatch({
      type: SET_PURCHASE_EXCHANGE_RATES,
      payload: res,
    });

    return Promise.resolve();
  });
};

export const updateBankAccounts =
  (data: IBankAccountProperties) => (dispatch: Function) => {
    dispatch({ type: UPDATE_BANK_ACCOUNTS, payload: data });
  };

export const setAccessingFundsAgreementCreatedAt =
  () => (dispatch: Function, getState: () => TReducers) => {
    dispatch({
      type: SET_API_ME,
      payload: {
        ...getState().userInfo,
        accessing_funds_agreement_created_at: new Date(),
      },
    });
  };

export const deleteBankAccount =
  (accountId: number) => (dispatch: Function) => {
    dispatch({ type: DELETE_BANK_ACCOUNT, payload: accountId });
  };

export const setBankFormDataAvailable =
  (data: boolean) => (dispatch: Function) => {
    dispatch({ type: SET_BANK_FORM_ADDRESS_DATA_AVAILABLE, payload: data });
  };

export const updateCryptoWallets =
  (data: IPrivateWallets, walletIdToRemove?: number) =>
  (dispatch: Function) => {
    dispatch({
      type: UPDATE_CRYPTO_WALLETS,
      payload: { data, walletIdToRemove },
    });
  };

export const deleteCryptoWallet =
  (walletId: number) => (dispatch: Function) => {
    dispatch({ type: DELETE_CRYPTO_WALLET, payload: walletId });
  };

export const updateWalletBalanceAfterTransaction =
  (data: TUpdateWalletData) => (dispatch: Function) => {
    dispatch({ type: UPDATE_WALLET_BALANCE_AFTER_TRANSACTION, payload: data });
  };

export const updateWalletsBalanceAfterCryptoTradeTransaction =
  (data: IUpdateWalletsData) => (dispatch: Function) => {
    dispatch({
      type: UPDATE_WALLETS_BALANCE_AFTER_CRYPTO_TRADE_TRANSACTION,
      payload: data,
    });
  };
